import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../components/common';
import { useCastedParams } from '../../lib/hooks';
import { getArea, getAreaBoundaries, getAreaTeams, selectAreaBoundaries, selectAreaTeams } from '../../redux';
import { AreaMap, AreaMapProvider } from './AreaMap';
import { AreaTeams } from './AreaTeams';
import '../../assets/scss/leaflet.scss';
const AreaDetails = () => {
    const dispatch = useDispatch();
    const { areaId } = useCastedParams(Number);
    const teamRepRef = useRef(null);
    const { areaBoundaries, isLoading: isAreaBoundariesLoading } = useSelector(selectAreaBoundaries);
    const { areaTeams, isLoading: isAreaTeamsLoading } = useSelector(selectAreaTeams);
    const teamOptions = useMemo(() => areaTeams.map(({ id: value, name, }) => ({
        name,
        value,
    })), [areaTeams]);
    const teamColors = useMemo(() => areaTeams.reduce((acc, { id, color }) => ({
        ...acc,
        [id]: color,
    }), {}), [areaTeams]);
    useEffect(() => {
        dispatch(getArea.request({ areaId }));
    }, [
        dispatch,
        areaId,
    ]);
    useEffect(() => {
        dispatch(getAreaBoundaries.request({ areaId }));
    }, [
        dispatch,
        areaId,
    ]);
    useEffect(() => {
        dispatch(getAreaTeams.request({ areaId }));
    }, [
        dispatch,
        areaId,
    ]);
    return (_jsxs("div", { className: "flow-root relative", children: [_jsx(Draggable, { nodeRef: teamRepRef, defaultPosition: { x: 10, y: 10 }, children: _jsx("div", { ref: teamRepRef, className: "overflow-visible rounded-lg touch-pan-auto top-0 absolute z-[1100] inline-block align-bottom bg-white text-left shadow-xl", children: _jsx(AreaTeams, { teams: areaTeams, loading: isAreaTeamsLoading }) }) }), isAreaBoundariesLoading ? (_jsx(Loader, { className: "w-full h-[800px] items-center" })) : (_jsx(AreaMapProvider, { children: _jsx(AreaMap, { zipcodes: areaBoundaries?.boundaries, center: areaBoundaries?.center, teamOptions: teamOptions, teamColors: teamColors }) }))] }));
};
export default AreaDetails;
